module.exports = __webpack_public_path__ + "img/Salih-Daglar.ae2f441e.webp";